import { __decorate, __metadata } from "tslib";
import { RelativePosition } from './RelativePosition';
import { SerializableObject, SerializableMember } from '../decorators';
import { LinearVelocity } from '../values';
import { LinearVelocityUnit } from '../../utils';
/**
 * Relative linear velocity to another reference object
 * @category Position
 */
let RelativeLinearVelocity = class RelativeLinearVelocity extends RelativePosition {
  constructor(referenceObject, velocity) {
    super(referenceObject, velocity, LinearVelocityUnit.METER_PER_SECOND);
  }
  get velocity() {
    return this.referenceValue;
  }
  set velocity(value) {
    this.referenceValue = value;
  }
};
__decorate([SerializableMember(), __metadata("design:type", LinearVelocity)], RelativeLinearVelocity.prototype, "referenceValue", void 0);
RelativeLinearVelocity = __decorate([SerializableObject(), __metadata("design:paramtypes", [Object, LinearVelocity])], RelativeLinearVelocity);
export { RelativeLinearVelocity };